import { isArray } from "lodash";

export function evaluateCriteria(productCriteria, objects) {
  const result = productCriteria.map((criteria) => {
    if (objects[criteria.object]) {
      if (
        objects[criteria.object][criteria.attribute] ||
        objects[criteria.object][criteria.attribute] === 0 ||
        (!objects[criteria.object][criteria.attribute] && criteria.condition === "isNot")
      ) {
        if (conditions[criteria.condition](criteria, objects[criteria.object][criteria.attribute])) {
          criteria.result = true;

          return criteria;
        }
      } else if (conditions[criteria.condition](criteria, objects[criteria.object])) {
        criteria.result = true;

        return criteria;
      }

      if (objects[criteria.object][criteria.attribute] === undefined) {
        criteria.result = undefined;

        return criteria;
      }

      criteria.result = false;

      return criteria;
    }

    criteria.result = undefined;

    return criteria;
  });

  return result;
}

export function calculateExtras(loading, objects) {
  return loading.filter((loadingItem) => {
    if (loadingItem && loadingItem.criteria) {
      const isMatch = loadingItem.criteria.reduce((boolean, criteria) => {
        if (objects[criteria.object]) {
          return conditions[criteria.condition](
            criteria,
            objects[criteria.object][criteria.attribute] || objects[criteria.object],
          )
            ? boolean
            : false;
        }
        return false;
      }, true);
      if (isMatch) return loadingItem;
    }

    return null;
  });
}

export function calculateLoading(loading, objects) {
  return loading.map((loadingItem) => {
    // console.log({ loadingItem })
    if (loadingItem && loadingItem.criteria) {
      const result = loadingItem.criteria.reduce((boolean, criteria) => {
        if (objects[criteria.object]) {
          return conditions[criteria.condition](
            criteria,
            objects[criteria.object][criteria.attribute] || objects[criteria.object],
          )
            ? boolean
            : false;
        }
        return false;
      }, true);

      loadingItem.result = result;
      return loadingItem;
    }
    return null;
  });
}

export function calculateFees(loading, objects) {
  return loading.filter((loadingItem) => {
    if (!loadingItem.criteria) return true;

    return loadingItem.criteria.reduce((boolean, criteria) => {
      if (objects[criteria.object]) {
        return conditions[criteria.condition](criteria, objects[criteria.object][criteria.attribute]) ? boolean : false;
      }
      return false;
    }, true);
  });
}

export const conditions = {
  is: ({ value }, attr) => value,
  isNot: ({ value }, attr) => !attr,
  zero: ({ value }, attr) => attr < 1 || !attr,
  equal: ({ value }, attr) => value === attr,
  notEqual: ({ value }, attr) => value !== attr,
  lessThan: ({ value }, attr) => attr < value,
  greaterThan: ({ value }, attr) => attr > value,
  lessThanOrEqualTo: ({ value }, attr) => attr < value || value === attr,
  greaterThanOrEqualTo: ({ value }, attr) => attr > value || value === attr,
  betweenLow: ({ value }, attr) => {
    const { min, max } = value ?? {};
    return attr >= min && attr <= max;
  },
  between: ({ value }, attr) => {
    const { min, max } = value ?? {};
    return attr >= min && attr <= max;
  },
  hasOne: ({ value }, attr) => 
    // console.log({ value, attr })
    (typeof value === 'string' || isArray(value)) && value.includes(attr)
    //  value !== 0 && value.includes(attr)
  ,
  eachIsGreaterThan: (criteria, objects) => {
    // Callers pass either a collection, a single object, or its attribute value.
    const items = isArray(objects) ? objects : [objects];
    if (items.length === 0) return undefined;

    const results = items.map((item) => {
      const attribute = item !== null && typeof item === "object" ? item[criteria.attribute] : item;
      return attribute == null ? undefined : attribute > criteria.value;
    });

    if (results.includes(undefined)) return undefined;
    return !results.includes(false);
  },
  sumIsGreaterThan: (criteria, objects) => {
    const items = isArray(objects) ? objects : [objects];
    const attributes = items.map((item) =>
      item !== null && typeof item === "object" ? item[criteria.attribute] : item,
    );
    if (attributes.length === 0 || attributes.some((attribute) => attribute == null)) return undefined;

    const total = attributes.reduce((accum, attribute) => attribute + accum, 0);
    return total > criteria.value * attributes.length;
  },
  exists: (criteria, objects) => {
    const items = isArray(objects) ? objects : [objects];
    const results = items.map((item) => {
      const attribute = item !== null && typeof item === "object" ? item[criteria.attribute] : item;
      return attribute == null ? undefined : criteria.value === attribute;
    });

    if (results.includes(true)) return true;
    if (results.includes(false)) return false;
    return undefined;
  },
  doesntExist: (criteria, objects) => {
    const result = conditions.exists(criteria, objects);
    return result === undefined ? undefined : !result;
  },
};
